export default __webpack_public_path__ + "static/1386-b91a73186cef46c9de132aead2d5d993.gif";